import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

export default function useUpdatedRef<T>(value: T): RefObject<T> {
  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  });

  return ref;
}
